export default {
  primaryColor: '#34A348',
  secondaryColor: '#0d4175'
}



// WEBPACK FOOTER //
// ./src/theme/colors/chart.js